import { useInfiniteQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { chat } from '../contract';
import { callApi } from '../services/api';
import { queryKeys } from './queryKeys';

export function useBoardChat(boardId: string) {
    return useInfiniteQuery({
        queryKey: queryKeys.chat(boardId),
        initialPageParam: undefined as string | undefined,
        queryFn: ({ pageParam }) => callApi(chat.getMessages, { params: { boardId }, query: { before: pageParam } }),
        getNextPageParam: (page) => page.nextBefore ?? undefined,
        refetchInterval: 5000,
        retry: (count, error: any) => error?.response?.status !== 403 && count < 2,
    });
}

export function useSendChatMessage(boardId: string) {
    const client = useQueryClient();
    return useMutation({
        mutationFn: (text: string) => callApi(chat.sendMessage, { params: { boardId }, body: { text } }),
        onSuccess: () => { void client.invalidateQueries({ queryKey: queryKeys.chat(boardId) }); },
    });
}
